import { ROUTES } from "@src/common/constants";

/** Electron production loads `/index.html`; map that to the app home route. */
export function getAuthReturnPathname(
	pathname: string = window.location.pathname,
): string {
	return pathname === "/index.html" ? ROUTES.home : pathname;
}

export function getAuthReturnTo(
	pathname: string = window.location.pathname,
	search: string = window.location.search,
): string {
	return `${getAuthReturnPathname(pathname)}${search}`;
}

/**
 * Invite links hit `/invite/:code` then redirect to `/whiteboards?ref=…`;
 * new users need the Auth0 signup screen.
 */
export function shouldUseSignupScreenHint(
	pathname: string,
	referralCode: string | null,
): boolean {
	return pathname.startsWith(`${ROUTES.invite}/`) || referralCode !== null;
}
